// noinspection JSUnusedGlobalSymbols

import Is from '../../../client/is'

export default class
{
	static init()
	{
		this.pay_method($('#pay_method').val())
		this.total()

		$('[data-disabled]').prop('disabled', true)
	}

	static total()
	{
		let total = {
			menu: 0,
			item: 0,
		}

		let discount = {
			percent: {
				all : 0,
				menu: 0,
				item: 0,
			},
			price  : 0,
			sale   : 0,
		}

		$('input._menu_discount_value:not([disabled])').each((index, element) =>
		{
			const value = Number($(element).val())
			const amount = Number($(element).parent().parent().parent().find('input[name="_menu_amount[]"]').val())

			const target = $(element).data('discount_target') || 'all'
			const type = $(element).data('discount_type')

			if(type === 'percent') discount.percent[target] += value * amount
			else discount.price += value * amount

			const sale = $(element).data('discount_is_sale') === 1
			if(sale) discount.sale += value * amount
		})

		$('input._menu_price:not([disabled])').each((index, element) =>
		{
			const type = $(element).data('type') === 'item' ? 'item' : 'menu'
			const amount = Number($(element).parent().parent().parent().find('input[name="_menu_amount[]"]').val())

			total[type] += Number($(element).val()) * amount
		})

		const normal = total.menu + total.item

		total.menu = Math.ceil(total.menu * (100 - discount.percent.menu - discount.percent.all) / 100)
		total.item = Math.ceil(total.item * (100 - discount.percent.item - discount.percent.all) / 100)

		let all = total.menu + total.item - discount.price
		if(all < 0) all = 0

		const currency = $('#total-total').data('unit')
		const reduction = normal - all

		$('#total-normal').text(normal.toLocaleString() + currency)
		$('#total-discount').text(reduction > 0 ? `-${reduction.toLocaleString() + currency}` : `0${currency}`)

		$('#total-total span').text(all.toLocaleString() + currency)

		$('#total-total input[name="total"]').val(String(all))
		$('#total-total input[name="sale"]').val(String(all + discount.sale))

		const tax = Number($('#total-tax').data('tax'))
		const subtotal = Math.ceil(all / ((100 + tax) / 100))

		$('#total-subtotal').text(subtotal.toLocaleString() + currency)
		$('#total-tax').text((all - subtotal).toLocaleString() + currency)

		this.show_change()
	}

	static pay_method(method)
	{
		if(method === 'cash')
		{
			$('#total-received').prop('disabled', false)
			$('#change, #received').show()

			$('#total-received').trigger('focus')
		}
		else
		{
			$('#total-received').prop('disabled', true)
			$('#change, #received').hide()
		}
	}

	static show_change()
	{
		const received = $('#total-received').val()

		const total = Number($('#total-total').text().replace(/\D/g, ''))
		const currency = $('#total-total').data('unit')

		let change

		if(!Is.float(received, true))
		{
			$('#total-change').addClass('_insufficient')
			change = $('#message-invalid_number').data('message')
		}
		else if(Number(received) < total)
		{
			$('#total-change').addClass('_insufficient')
			change = $('#message-insufficient').data('message')
		}
		else
		{
			$('#total-change').removeClass('_insufficient')
			change = (Number(received) - total).toLocaleString() + currency
		}

		$('#total-change').text(change)
	}

	static add_menu(selector, type, discount_type, discount_is_sale, discount_target, discount_target_name)
	{
		const row = $(`#${selector}`)
		const template = $('#template').clone()

		template.attr('id', null)
		template.removeClass('hidden')

		for(const input of ['_menu_staff_id', '_menu_price', '_menu_discount_type', '_menu_discount_value', '_menu_amount', '_menu_id'])
		{
			template.find(`[name="${input}[]"]`).prop('disabled', false)
		}

		template.find('._menu_id').val(row.data('id'))
		template.find('._menu_duration').text(row.find('._menu_duration').text())
		template.find('._menu_price').val(row.find('._menu_price').text().replace(/\D/g, ''))

		let name = row.find('._menu_name').text()
		if(type === 'discount') name += ` (${$('#message-target').data('message')} : ${discount_target_name})`

		template.find('._menu_name').text(name)
		template.find('._menu_price').data('type', type)

		switch(type)
		{
			case 'item' :
			break

			case 'discount' :
				template.find('._menu_discount_area').removeClass('!hidden')
				template.find('._menu_price_area').addClass('!hidden')

				const discount_value = row.find('._menu_discount').text()

				if(discount_type === 'percent')
				{
					template.find('._discount_currency').addClass('!hidden')
					template.find('._discount_percent').removeClass('!hidden')
				}

				template.find('input[name="_menu_discount_type[]"]').val(discount_type)

				template.find('input[name="_menu_discount_value[]"]')
				.val(discount_value.replace(/\D/g, ''))
				.attr('data-discount_type', discount_type)
				.attr('data-discount_target', discount_target)
				.attr('data-discount_is_sale', discount_is_sale)
			break

			default :
				template.find('._menu_amount').attr('type', 'hidden')
				template.find('._menu_single').removeClass('hidden')
			break
		}

		$('#template').parent().append(template)
		row.hide()

		this.total()
	}

	static remove_menu(link, remove = false)
	{
		const row = $(link).parent().parent()
		const id = $(link).siblings('input[type="hidden"]').val()

		if(remove)
		{
			row.remove()
			$(`#menu-${id}`).show()

			this.total()
			return
		}

		const input = $(row).find('input, select')

		const removed = row.hasClass('_removed')
		input.prop('disabled', !removed)

		row.toggleClass('_removed')

		const icon = $(link).find('i')
		icon.toggleClass('fa-trash').toggleClass('fa-rotate-right')

		link.title = $(link).data(`lang-${removed ? 'on' : 'off'}`)
		this.total()
	}
}
